// Handling login APIs

jQuery(function ($) {
  const apiToken =
    "eyJpdiI6ImtrTm0xTSsrTHBkdk5yMEJmcndSWHc9PSIsInZhbHVlIjoiWTJQS3ZRVDI3ai9RQ0RkUUZScEIzVE90V2VRbGFuWjh6dTVqYzRvSjVXRT0iLCJtYWMiOiI0MTM0MWYyMDZiNTMxZmE2YjZhMzgyNGMzOTdiZjkzOWE2OGI3YzIzOGZiMjA2OWE5YjIxYTNmNTMxODFkNWU4IiwidGFnIjoiIn0=";

  // $(".user-logout").on("click", function () {

  //   console.log("logging out...");

  //   const logout_token = localStorage.getItem("idea-logout-token");

  //   $.ajax({
  //     url: "/session/token",
  //     method: "GET",
  //     success: function (response) {
  //       $.ajax({
  //         url: "/user/logout?_format=json&token=" + logout_token,
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-Token": response,
  //           // "Authorization": "Bearer " + sessionStorage.getItem("session_token"),
  //           // "X-Logout-Token": "gvUoUIFB58_TQKfJRi_jbU9qslNoj9Dnj39JqA-o99s"
  //         },
  //         success: function (response) {
  //           // Log out successful
  //           console.log("logged out");
  //           sessionStorage.removeItem("session_token");
  //           window.location = "/";
  //         },
  //         error: function (xhr, status, error) {
  //           // Log out failed
  //           console.log(xhr.responseText);
  //         },
  //       });
  //     },
  //     error: function (xhr, status, error) {
  //       // Log out failed
  //       console.log(xhr.responseText);
  //     },
  //   });
  // });

  const formLogin = $("#login-modal");
  const url = "https://accesspass.io";

  // if (document.getElementById("login-modal")) {
  //   const loginSubmitButton = document.getElementById("loginSubmitButton");

  //   const redirectPath = formLogin.data('redirect');
  //   console.log(redirectPath);

  //   loginSubmitButton.addEventListener("click", (event) => {
  //     event.preventDefault(); // Prevent the form from submitting traditionally

  //     var username = $("#loginEmail").val();
  //     var password = $("#loginPassword").val();

  //     var data = {
  //       username: username,
  //       password: password,
  //     };

  //     console.log(data);
  //     const url = "https://accesspass.io";

  //     $.ajax({
  //       url: url + "/auth/login",
  //       method: "POST",
  //       data: JSON.stringify(data),
  //       dataType: "json",
  //       // headers: {
  //       //   "Content-Type": "application/json",

  //       // },
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Accept": "application/json",
  //       },
  //       success: function (response) {
  //         // Authentication successful
  //         console.log("logged in");
  //         localStorage.setItem("token", response.result.token);
  //         window.location = redirectPath;
  //       },
  //       error: function (response) {
  //         // Authentication error
  //         console.error("Login error:", response.message);
  //       },
  //     });
  //   });
  // }

  if (document.getElementById("login-modal")) {
    const loginSubmitButton = document.getElementById("loginSubmitButton");

    // const redirectPath = formLogin.data('redirect');
    // console.log(redirectPath);

    loginSubmitButton.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent the form from submitting traditionally

      var username = $("#loginEmail").val();
      var password = $("#loginPassword").val();

      var data = {
        username: username,
        password: password,
      };

      console.log(data);

      var userName;

      const loaderElement = document.querySelector(".loader-black");
      loaderElement.classList.add("active");

      $.ajax({
        url: url + "/api/auth/login",
        method: "POST",
        data: JSON.stringify(data),
        dataType: "json",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Api-Token": apiToken,
        },
        success: function (response) {
          // Authentication successful
          console.log('sond', response);
          document.body.style.overflow = "auto";
          localStorage.setItem("login-token", response.result.token);
          localStorage.setItem(
            "user-response",
            JSON.stringify(response.result)
          );
          userName = response.result.first_name;

          var loginModal = document.getElementById("login-modal");
          if (loginModal) {
            loginModal.style.display = "none";
          }

          const user_response = localStorage.getItem("user-response");
          const userObject = JSON.parse(user_response);

          console.log(userObject.first_name);


          if (userObject.first_name != null) {
            $("#top-name").html("Hallo, " + userObject.first_name);
          }
          $("#register-btn").show();
          $("#login-btn").hide();
          const miniHeaderLogin = document.querySelector(".miniHeaderLogin");
          const miniHeaderHello = document.querySelector(".miniHeaderHello");
          miniHeaderLogin.classList.add("hidden");
          miniHeaderLogin.classList.remove("menu-login");
          miniHeaderHello.classList.remove("hidden");
          miniHeaderHello.classList.add("menu-login");
        },
        error: function (error) {
          // Authentication error
          console.error("Login error:", error.responseJSON.message);
          document.getElementById("errorMessage").innerHTML =
            '<div class="error">' + error.responseJSON.message + "</div>";
          loaderElement.classList.remove("active");
        },
      });
    });
  }

  if (localStorage.getItem("user-response")) {
    const user_response = localStorage.getItem("user-response");
    const userObject = JSON.parse(user_response);

    console.log(userObject.first_name);
    if (userObject.first_name != null) {
      $("#top-name").html("Hallo, " + userObject.first_name);
    }
    const miniHeaderLogin = document.querySelector(".miniHeaderLogin");
    const miniHeaderHello = document.querySelector(".miniHeaderHello");
    miniHeaderLogin.classList.add("hidden");
    miniHeaderHello.classList.remove("hidden");
  }

  $(".user-logout").on("click", function () {
    console.log("logging out...");

    const logout_token = localStorage.getItem("login-token");
    const user_response = localStorage.getItem("user-response");

    $.ajax({
      url: url + "/api/auth/logout",
      type: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + logout_token,
      },
      success: function (response) {
        // Logout successful
        console.log(response);
        localStorage.removeItem("login-token"); // Correct the item name
        localStorage.removeItem("user-response"); // Correct the item name
        window.location = "/";
        localStorage.clear();
        sessionStorage.clear();
      },
      error: function (error) {
        // Handle error
      },
    });

    //   // $.ajax({
    //   //   url: url + "/api/auth/logout",
    //   //   method: "GET",
    //   //   success: function (response) {
    //   //     $.ajax({
    //   //       url: "/user/logout?_format=json&token=" + logout_token,
    //   //       method: "POST",
    //   //       headers: {
    //   //         "Content-Type": "application/json",
    //   //         "X-CSRF-Token": response,
    //   //         // "Authorization": "Bearer " + sessionStorage.getItem("session_token"),
    //   //         // "X-Logout-Token": "gvUoUIFB58_TQKfJRi_jbU9qslNoj9Dnj39JqA-o99s"
    //   //       },
    //   //       success: function (response) {
    //   //         // Log out successful
    //   //         console.log('logged out');
    //   //         sessionStorage.removeItem("session_token");
    //   //         window.location = '/';
    //   //       },
    //   //       error: function (xhr, status, error) {
    //   //         // Log out failed
    //   //         console.log(xhr.responseText);
    //   //       }
    //   //     });
    //   //   },
    //   //   error: function (xhr, status, error) {
    //   //     // Log out failed
    //   //     console.log(xhr.responseText);
    //   //   }
    //   // });
    // });
  });
});
